import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EMessageChannel, EMessageVisibility } from './message';
import { EModel } from './model';
export let EMessageRequestRecipientType;
(function (EMessageRequestRecipientType) {
  EMessageRequestRecipientType["Staff"] = "staff";
  EMessageRequestRecipientType["Patient"] = "patient";
  EMessageRequestRecipientType["Doctor"] = "doctor";
})(EMessageRequestRecipientType || (EMessageRequestRecipientType = {}));
export let EMessageRequestStatus;
(function (EMessageRequestStatus) {
  EMessageRequestStatus["Sent"] = "sent";
  EMessageRequestStatus["Received"] = "received";
  EMessageRequestStatus["Delivered"] = "delivered";
  EMessageRequestStatus["Undelivered"] = "undelivered";
})(EMessageRequestStatus || (EMessageRequestStatus = {}));
export const fieldsMessageRequest = _extends({}, fieldsIBaseModel, {
  callbackQueue: {
    type: 'Text'
  },
  cbUrl: {
    type: 'Text'
  },
  channel: {
    type: 'Option',
    values: EMessageChannel
  },
  contact: {
    type: 'Text'
  },
  context: {
    type: 'Unknown'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  recipient: {
    type: 'ID',
    ref: EModel.User
  },
  recipientType: {
    type: 'Option',
    values: EMessageRequestRecipientType
  },
  ref: {
    type: 'Text'
  },
  refId: {
    type: 'Text'
  },
  secure: {
    type: 'Boolean'
  },
  sender: {
    type: 'Text'
  },
  senderName: {
    type: 'Text'
  },
  status: {
    type: 'Option',
    values: EMessageRequestStatus
  },
  statusReason: {
    type: 'Text'
  },
  template: {
    type: 'Text'
  },
  text: {
    type: 'Text'
  },
  user: {
    type: 'ID',
    ref: EModel.User
  },
  visibility: {
    type: 'Option',
    values: EMessageVisibility
  }
});